export const appEnvType = {
  development: "Development",
  staging: "Staging",
  production: "Production",
};
